module.exports = __webpack_public_path__ + "img/about.50c244df.png";